import script from "./about-page.vue?vue&type=script&setup=true&lang=js"
export * from "./about-page.vue?vue&type=script&setup=true&lang=js"

import "./about-page.vue?vue&type=style&index=0&id=e50a0588&lang=css"

const __exports__ = script;

export default __exports__